import React from 'react';
interface BarPoint { label: string; value: number; }
interface Props { data: BarPoint[]; title?: string; }
export const SvgBarChart: React.FC<Props> = ({ data, title }) => {
  const max = Math.max(...data.map((d) => d.value), 1); const height = 180; const barWidth = data.length ? 300 / data.length : 0;
  return (
    <div>
      {title && <h3 className="font-semibold mb-2">{title}</h3>}
      <svg role="img" aria-label={title} width="100%" height={height} viewBox={`0 0 320 ${height}`}>
        {data.map((d, idx) => { const h = (d.value / max) * (height - 20); return (<g key={d.label} transform={`translate(${10 + idx * barWidth}, ${height - h - 10})`}><title>{`${d.label}: ${d.value}`}</title><rect width={barWidth - 8} height={h} fill="#60a5fa" rx={3} /><text x={(barWidth - 8) / 2} y={h + 12} textAnchor="middle" fontSize="10">{d.label}</text></g>); })}
      </svg>
    </div>
  );
};
